module.exports = __webpack_public_path__ + "img/pic_order_cart.b5e89b47.png";